var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShikuLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4972 94.7458L83.6124 86.2411C92.2516 81.2823 95.2435 70.222 90.2835 61.5861C85.3235 52.9477 74.2594 49.9565 65.6226 54.9166L60.7378 46.4119C67.1956 42.7058 74.7106 41.7359 81.8958 43.6789C89.0828 45.6219 95.0833 50.248 98.7902 56.703C106.444 70.0279 101.826 87.0946 88.4966 94.7464L88.4972 94.7458Z",
    fill: "#0040DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.913 84.0468C50.4697 84.0468 48.0115 83.7226 45.5898 83.0676C38.4027 81.1246 32.4023 76.4985 28.6953 70.0434C21.0429 56.7173 25.6609 39.6518 38.9889 32L43.8738 40.5047C35.2358 45.4635 32.2438 56.5238 37.2026 65.1597C42.1639 73.7981 53.2268 76.7869 61.8635 71.8292L66.7484 80.3339C62.467 82.7915 57.7208 84.0461 52.9136 84.0461L52.913 84.0468Z",
    fill: "#0040DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1014 65.8931C54.8605 65.8931 58.7185 62.036 58.7185 57.2781C58.7185 52.5201 54.8605 48.6631 50.1014 48.6631C45.3424 48.6631 41.4844 52.5201 41.4844 57.2781C41.4844 62.036 45.3424 65.8931 50.1014 65.8931Z",
    fill: "#00B56E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8353 76.5762C81.5944 76.5762 85.4523 72.7191 85.4523 67.9612C85.4523 63.2033 81.5944 59.3462 76.8353 59.3462C72.0762 59.3462 68.2183 63.2033 68.2183 67.9612C68.2183 72.7191 72.0762 76.5762 76.8353 76.5762Z",
    fill: "#00B5DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShikuLogo);
export default __webpack_public_path__ + "static/media/shikuLogo.0dfb2186534125fa21d7cd521b45f471.svg";
export { ForwardRef as ReactComponent };